<template>
  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid">
      <img src="@/assets/statics/smartmatic-logo.svg" title="Smartfiles logo" alt="Smartfiles logo" width="150" class="d-inline-block align-text-top">
      <div>
        &copy; {{ thisYear() }} Smartmatic
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  methods: {
    thisYear() {
      const current = new Date()
      return current.getFullYear()
    }
  },
}
</script>